import { useMount } from "react-use";
import {
  atomFamily,
  selectorFamily,
  SetterOrUpdater,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { TXGUIField } from "../utils/interfaces/gui/fields.interfaces";
import { TComponentName } from "../utils/types/common/components.types";
import { isCommon, USE_X_COMMON } from "./useXCommon";
import { IDataFetching } from "./useXoraia";

export type TUseXElement<T> = {
  name: TComponentName;

  value: T;

  index: string;

  elementsIndexes: string[];

  hierachy: string;

  /**
   * @deprecated
   */
  guiFields?: TXGUIField[];

  /**
   * @deprecated
   * */
  element?: HTMLElement;

  hasChildren: boolean; // use this on containers

  childOf: string | null; // to reorder element

  dataFetching?: IDataFetching;
};

export const USE_X_ELEMENT = atomFamily<any, string | null>({
  key: "USE_X_ELEMENT",
  default: {},
  // effects_UNSTABLE: [persistAtom],
});

export const USE_X_ELEMENT_SELECTOR = selectorFamily<any, string>({
  key: "USE_X_ELEMENT_SELECTOR",
  get: (id: string) => (opts) => {
    if (isCommon(id)) return opts.get(USE_X_COMMON(id));

    return opts.get(USE_X_ELEMENT(id));
  },
  set: (id: string) => (opts, newValue) => {
    if (isCommon(id)) return opts.set(USE_X_COMMON(id), newValue);

    return opts.set(USE_X_ELEMENT(id), newValue);
  },
});

export function useXElement<T = {}>(
  index: string,
  initData?: T
): { xElement: T; setXElement: SetterOrUpdater<T> } {
  const [xElement, setXElement] = useRecoilState(USE_X_ELEMENT_SELECTOR(index));

  useMount(() => {
    if (initData) {
      setXElement(initData);
    }
  });

  return { xElement, setXElement };
}

export function useXElementValue<T = {}>(index: string): TUseXElement<T> {
  return useRecoilValue(USE_X_ELEMENT_SELECTOR(index));
}

export function useXElementUpdater<T = {}>(
  index: string
): SetterOrUpdater<TUseXElement<T>> {
  return useSetRecoilState(USE_X_ELEMENT_SELECTOR(index));
}
